#debug{top:16px;right:16px;width:352px;padding:12px 14px;font-size:.72rem;
  line-height:1.5;z-index:6}
.debug-title{font-size:.6rem;letter-spacing:.19em;text-transform:uppercase;
  color:var(--accent);margin-bottom:8px}
#debug .r{display:grid;grid-template-columns:74px 1fr;gap:2px 8px;
  align-items:baseline}
#debug .r b{color:var(--dim);font-weight:400;font-size:.64rem;
  letter-spacing:.1em;text-transform:uppercase}
#debug .r span{color:var(--ink);font-variant-numeric:tabular-nums;
  white-space:pre}
#debug .r i{grid-column:2;font-style:normal;color:var(--dim);font-size:.66rem}
#debug hr{border:0;border-top:1px solid var(--edge);margin:8px 0}
#debug .hint{margin-top:9px;color:var(--dim);font-size:.62rem;
  letter-spacing:.1em;text-transform:uppercase}
#debug-cross{position:fixed;left:50%;top:50%;width:15px;height:15px;
  margin:-7px 0 0 -7px;z-index:6;pointer-events:none;
  background:
    linear-gradient(var(--accent),var(--accent)) 50% 0/1px 6px no-repeat,
    linear-gradient(var(--accent),var(--accent)) 50% 100%/1px 6px no-repeat,
    linear-gradient(var(--accent),var(--accent)) 0 50%/6px 1px no-repeat,
    linear-gradient(var(--accent),var(--accent)) 100% 50%/6px 1px no-repeat}
#debug-toast{bottom:60px;right:16px;padding:7px 12px;font-size:.66rem;
  letter-spacing:.14em;text-transform:uppercase;color:var(--accent);z-index:7}
